import { render, staticRenderFns } from "./RenewalInplayMobileDetail.vue?vue&type=template&id=0a50f8b5&scoped=true"
import script from "./RenewalInplayMobileDetail.vue?vue&type=script&lang=js"
export * from "./RenewalInplayMobileDetail.vue?vue&type=script&lang=js"
import style0 from "./RenewalInplayMobileDetail.vue?vue&type=style&index=0&id=0a50f8b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a50f8b5",
  null
  
)

export default component.exports